import { getAll } from "./get-all"

export const plans = {
  getAll,
}
